import { defer } from 'lodash'
import type { FileId } from '../../../shared/domain/files/types.no-deps'
import type { UploadGroupId } from '../../../app-core/lib/upload/Upload'
import { extractFileExtension, allFileExtensions } from '../../../shared/domain/files/fileExtensions.no-deps'
import { createFileName } from '../../../shared/domain/flows/types.no-deps'
import { createFileUploadData } from '../../../app-core/lib/upload/FileUploadData'
import { appUploadQueue } from './AppUploadQueue'
import { writeArrayBufferToDisk } from './writeArrayBufferToDisk'
import { removeFileEntry, resolveLocalFile } from '../Imag/Imag.readFromFile'
import { fileBuffer } from '../../../app-core/lib/upload/buffer'
import { Logg_createLogger } from '../Logg/Logg.Logger'

export async function saveFile(fileId: FileId, groupId: UploadGroupId, path: string, customer: number) {
    const logger = Logg_createLogger('Uplo.saveFile')

    const fileExtension = extractFileExtension(path)
    const fileName = createFileName(fileId, fileExtension)
    const { file, fileEntry } = await resolveLocalFile(path)

    const fileUploadData = createFileUploadData(fileId, fileName, file.size, file.type)
    await appUploadQueue.addUpload(fileUploadData, allFileExtensions, undefined, customer, groupId)

    // Do not hold up UI whilst saving to disk
    defer(async () => {
        try {
            await writeArrayBufferToDisk(fileId, fileBuffer(file))
            await appUploadQueue.writeToDiskComplete(fileId, logger)
        } catch (error) {
            logger.error(error)
            await appUploadQueue.failedToWriteToDisk(fileId, logger)
        }

        await removeFileEntry(fileEntry)
    })
}
